import React, {Component, PropTypes} from 'react';
import {Link} from "react-router";
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'COMPONENT/tip'
import {resultTip, language, errorShow} from 'UTIL/common'
import userService from 'SERVICES/ella/userService'
export default class AdministratorsAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            s_county: "",
            id: this.props.params.id,
        };
    }
    componentDidMount() {
        var scrollFunc=function(e){
            e=e || window.event;
            if(e.wheelDelta){//IE/Opera/Chrome
                $("#laydate_box").hide()
            }else if(e.detail){//Firefox
                $("#laydate_box").hide()
            }
        }
        /*注册事件*/
        if(document.addEventListener){
            document.addEventListener('DOMMouseScroll',scrollFunc,false);
        }
        window.onmousewheel=document.onmousewheel=scrollFunc;
        setTimeout("_init_area()", 200);
        userService.businessinIt(this.state.id).then(body => {
            console.log(body)
            var data = body.data;
            $("#merchantName").val(data.merchantName).attr('disabled','disabled');
            $("#contactName").val(data.contactName).attr('disabled','disabled');
            // $("#contactTelephone").val(data.contactTelephone).attr('disabled','disabled');
            $("#loginName").val(data.loginName).attr('disabled','disabled');
            $("#address").val(data.address).attr('disabled','disabled');
            var address = data.province + "-" + data.city + "-" + data.area;
            $("#addressVal").val(address)
            $("#remark").val(data.remark).attr('disabled','disabled');

        })
    }

    render() {
        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['userManage']}
                        <small>{language()['businessDetail']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['businessDetail']}</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <form id="micaFrom" className="form-horizontal">
                                <FormInput name="businessName" id="merchantName"/>
                                <FormInput name="contacts" id="contactName"/>
                                {/* <FormInput name="contactTelephone" id="contactTelephone"/> */}
                                <input type="hidden" id="addressVal" defaultValue={this.state.s_county}/>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()["region"]}</label>
                                    <div className="col-xs-6">
                                        <select id="s_province" style={{height: "34px", width: "125px"}}
                                                name="s_province" disabled></select>
                                        <select id="s_city"style={{height: "34px", width: "125px",marginLeft:"10px"}}
                                                name="s_city" disabled></select>
                                        <select id="s_county"  name="s_county"style={{height: "34px", width: "125px",marginLeft:"10px"}} disabled></select>
                                    </div>
                                    <span className = "">
                                            <span id="error_region"  name="success" ></span>
                                            <span className = ""></span>
                                    </span>
                                        <p className="form-control-static text-danger">
                                            <span style={{fontSize: "20px"}}>*</span>
                                        </p>
                                </div>
                                <FormInput name="addressDetail" id="address"/>
                                <FormInput name="APPAccount" id="loginName"/>
                                <div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['remark']}</label>
									<div className="col-xs-3">
										<textarea className="form-control" rows="3" id="remark"></textarea>
									</div>
								</div>
                            </form>
                        </div>
                        <div className="box-footer">
                            <div className="col-xs-2"></div>
                            <div className="col-xs-1 text-center">
                                <Link to='/ella/user/user/businessList' className="btn btn-default btn-md">
                                    {language()['return']}
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/businessDetail.js